import { Delete, Restore } from "@mui/icons-material";
import { IconButton, Typography } from "@mui/material";

import CoAppDataGridDateTimeCell from "../../global/components/datagrid/CoAppDataGridDateTimeCell";
import CoAppDataGridNameCell from "../../global/components/datagrid/CoAppDataGridNameCell";
import CoAppDataGridSkeletonCell from "../../global/components/datagrid/CoAppDataGridSkeletonCell";
import { CoAppDataGridTextCellContainer, CoAppLightTooltip } from "../../global/styled/global.styled";
import RuleDataGridLongTextCell from "../RuleDataGridLongTextCell";

// Calculate days until permanent deletion
export const getDifferenceInDays = (dateToCompare) => {
	let now = new Date();
	const thirtyDaysAgo = new Date(now.setDate(now.getDate() - 30));
	const diffInMs = Math.abs(thirtyDaysAgo - dateToCompare);
	return Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
};

const customDeletionInComparator = (v1, v2) => {
	if (!v1 && !v2) return;
	return v1 - v2;
};

export const ruleTrashColumns = ["delete", "restore", "name", "ruleLocation", "description", "permanentDeletionIn", "dateTimeTrashed", "platform"];

export const getRuleTrashColumns = (
	handleDeleteRuleToggle,
	handleRestoreRule,
	loading,
	theme
) => {
	return [
		{
			field: "name",
			headerName: "Rule name",
			flex: 1,
			sortable: true,
			renderCell: (params) => (
				<CoAppDataGridSkeletonCell
					cellToRender={<RuleDataGridLongTextCell value={params.value} isTrashed={true} />}
					isLoading={loading}
				/>
			)
		},
		{
			field: "platform",
			headerName: "Platform",
			flex: 1,
			sortable: true,
			valueGetter: (params) => params?.name,
			renderCell: (params) => (
				<CoAppDataGridSkeletonCell
					cellToRender={
						<RuleDataGridLongTextCell value={params.row.platform?.name || " "} />
					}
					isLoading={loading}
				/>
			)
		},
		{
			field: "ruleLocation",
			headerName: "Location",
			flex: 1,
			sortable: true,
			valueGetter: (params) => params?.name,
			renderCell: (params) => (
				<CoAppDataGridSkeletonCell
					cellToRender={<CoAppDataGridNameCell item={params.value} />}
					isLoading={loading}
				/>
			)
		},
		{
			field: "description",
			headerName: "Description",
			flex: 1,
			sortable: true,
			renderCell: (params) => (
				<CoAppDataGridSkeletonCell
					cellToRender={<RuleDataGridLongTextCell value={params.value} isTrashed={true} />}
					isLoading={loading}
				/>
			)
		},
		{
			field: "permanentDeletionIn",
			headerName: "Permanent deletion in",
			flex: 1,
			sortable: true,
			sortComparator: customDeletionInComparator,
			renderCell: (params) => {
				const diff = getDifferenceInDays(new Date(params.row.dateTimeTrashed));
				return (
					<CoAppDataGridSkeletonCell
						cellToRender={
							<CoAppDataGridTextCellContainer>
								<Typography variant="body2" color="text.disabled">{`${diff === 1 ? `${diff} day` : `${diff} days`}`}</Typography>
							</CoAppDataGridTextCellContainer>
						}
						isLoading={loading}
					/>
				);
			},
			filterable: false
		},
		{
			field: "dateTimeTrashed",
			headerName: "Moved to trash",
			flex: 1,
			type: "dateTime",
			valueGetter: (params) => !params ? null : new Date(params),
			sortable: true,
			renderCell: (params) => (
				<CoAppDataGridSkeletonCell
					cellToRender={<CoAppDataGridDateTimeCell value={params.value} isTrashed={true} />}
					isLoading={loading}
				/>
			)
		},
		{
			field: "delete",
			type: "actions",
			sortable: false,
			flex: .15,
			renderCell: (params) => (
				<CoAppDataGridSkeletonCell
					cellToRender={
						<CoAppLightTooltip title="Permanently delete">
							<IconButton onClick={() => handleDeleteRuleToggle(params.row)}>
								<Delete sx={{ color: theme.palette.icon.red }} />
							</IconButton>
						</CoAppLightTooltip>
					}
					isLoading={loading}
				/>
			)
		},
		{
			field: "restore",
			type: "actions",
			sortable: false,
			flex: .15,
			renderCell: (params) => (
				<CoAppDataGridSkeletonCell
					cellToRender={(
						<CoAppLightTooltip title="Restore">
							<IconButton onClick={() => handleRestoreRule(params.row.id)}>
								<Restore sx={{ color: theme.palette.icon.grey }} />
							</IconButton>
						</CoAppLightTooltip>
					)}
					isLoading={loading}
				/>
			)
		}
	];
};